import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { UserNotificationCardProps } from "./types";
import { useCallback, useContext, useState } from "react";
import { UpdateUserNotificationDto } from "../../../../models/UserNotifications";
import {
	FormControl,
	IconButton,
	InputLabel,
	OutlinedInput,
	CardContent,
	CardActions,
	Card,
	CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import UserNotificationApi from "../../../../api/user-notification";
import { useBus } from "react-bus";
import { AppContext } from "../../../../Contexts/AppContext";
import { isAxiosError } from "axios";
import { DeleteForever } from "@mui/icons-material";
import DeleteUserNotificationModal from "../DeleteUserNotificationModal/DeleteUserNotificationModal";

export default function UserNotificationCard(props: UserNotificationCardProps) {
	const { userNotification, openUserNotificationToDeleteModal } = props;
	const bus = useBus();
	const [updateNotificationDto, setUpdateNotificationDto] =
		useState<UpdateUserNotificationDto>({
			email: userNotification.email,
			name: userNotification.name,
		});
	const [loading, setLoading] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const { snackBar, setSnackBar } = useContext(AppContext);
	const update = useCallback(async () => {
		const updateDto: UpdateUserNotificationDto = {
			email:
				updateNotificationDto.email !== userNotification.email
					? updateNotificationDto.email
					: undefined,
			name:
				updateNotificationDto.name !== userNotification.name
					? updateNotificationDto.name
					: undefined,
		};

		if (!updateDto.email && !updateDto.name) {
			setSnackBar({
				...snackBar,
				open: true,
				message: "No se ha modificado ningun campo",
				autoHideDuration: 6000,
				severity: "warning",
			});
			return;
		}
		setLoading(true);
		try {
			await UserNotificationApi.update({
				accessToken: localStorage.getItem("accessToken"),
				id: userNotification._id,
				updateDto,
			});

			bus.emit("reloadUserNotifications");
			setSnackBar({
				...snackBar,
				open: true,
				message: "Notificacion actualizada con exito",
				autoHideDuration: 6000,
				severity: "success",
			});
		} catch (error) {
			console.error("Error updating notification", error);
			let errMsg = "Error al crear la notificacion";
			if (isAxiosError(error)) {
				errMsg = error.response?.data?.message || errMsg;
			}
			setSnackBar({
				...snackBar,
				open: true,
				message: errMsg,
				autoHideDuration: 6000,
				severity: "error",
			});
		} finally {
			setLoading(false);
			setIsEditMode(false);
		}
	}, [updateNotificationDto]);
	return (
		<Card sx={{ width: "80%", margin: 5 }}>
			<CardContent>
				{!isEditMode && (
					<>
						<IconButton
							color={"primary"}
							aria-label='toggle password visibility'
							onClick={() => {
								setIsEditMode(true);
							}}
							sx={{
								fontSize: "clamp(1rem, 4vw, 2rem)",
							}}
							edge='end'>
							<EditIcon />
						</IconButton>
						<IconButton
							color={"error"}
							aria-label='toggle password visibility'
							sx={{
								fontSize: "clamp(1rem, 4vw, 2rem)",
							}}
							onClick={() => {
								openUserNotificationToDeleteModal(userNotification);
							}}
							edge='end'>
							<DeleteForever />
						</IconButton>
					</>
				)}
				{isEditMode && (
					<IconButton
						color={"error"}
						sx={{
							fontSize: "clamp(1rem, 4vw, 2rem)",
						}}
						onClick={() => {
							setIsEditMode(false);
							setUpdateNotificationDto({
								email: userNotification.email,
								name: userNotification.name,
							});
						}}>
						<CancelIcon />
					</IconButton>
				)}
				<div>
					{!isEditMode && (
						<Typography
							sx={{
								color: "text.secondary",
								mb: 1.5,
								fontSize: "clamp(1rem, 4vw, 2rem)",
							}}>
							{userNotification.email}
						</Typography>
					)}
					{isEditMode && (
						<div style={{ marginBottom: "15px", width: "100%" }}>
							<FormControl
								disabled={loading}
								sx={{ m: 1, width: "80%" }}
								variant='outlined'>
								<InputLabel htmlFor='outlined-adornment-email'>
									Email
								</InputLabel>
								<OutlinedInput
									id='outlined-adornment-email'
									type={"text"}
									placeholder='Email'
									label='Email'
									multiline
									value={updateNotificationDto.email}
									onChange={(event) => {
										setUpdateNotificationDto({
											...updateNotificationDto,
											email: event.target.value,
										});
									}}
									onKeyUp={(event) => {
										if (event.key === "Enter") {
											update();
										}
									}}
								/>
							</FormControl>
						</div>
					)}
				</div>

				<div>
					{!isEditMode && (
						<Typography
							sx={{
								color: "text.secondary",
								mb: 1.5,
								fontSize: "clamp(1rem, 4vw, 2rem)",
							}}>
							{userNotification.name}
						</Typography>
					)}
					{isEditMode && (
						<div style={{ marginBottom: "15px", width: "100%" }}>
							<FormControl
								disabled={loading}
								sx={{ m: 1, width: "80%" }}
								variant='outlined'>
								<InputLabel htmlFor='outlined-adornment-name'>
									Nombre
								</InputLabel>
								<OutlinedInput
									id='outlined-adornment-name'
									type={"text"}
									placeholder='Nombre'
									label='Nombre'
									multiline
									value={updateNotificationDto.name}
									onChange={(event) => {
										setUpdateNotificationDto({
											...updateNotificationDto,
											name: event.target.value,
										});
									}}
									onKeyUp={(event) => {
										if (event.key === "Enter") {
											update();
										}
									}}
								/>
							</FormControl>
						</div>
					)}
				</div>
				<Typography
					gutterBottom
					sx={{
						color: "text.secondary",
						fontSize: "clamp(1rem, 4vw, 2rem)",

						fontWeight: "bold",
					}}>
					Email
				</Typography>
			</CardContent>
			{isEditMode && (
				<CardActions
					sx={{
						justifyContent: "center",
					}}>
					{!loading && (
						<Button size='small' onClick={() => update()}>
							Guardar
						</Button>
					)}
					{loading && <CircularProgress size={30} />}
				</CardActions>
			)}
		</Card>
	);
}
